define( [
	"./arr"
], function( arr ) {
	"use strict";

	return arr.slice;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/slice.js
// module id = q1LG
// module chunks = 0 1